import {PublisherData} from './PublisherDashboard';
import ReactEcharts from 'echarts-for-react';

interface Props {
    pubDat: PublisherData[],
    style: {}
}

const PublisherPieChart = (props: Props) => {

    const data = props.pubDat.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push({value: pData.revenue, name: pData.name});
        }
        return result;
    }, []);

    const labelData = props.pubDat.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push(pData.name);
        }
        return result;
    }, []);

    const option = {
        title: {
            text: 'Revenue',
            subtext: 'by Dsp',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                type: 'pie',
                radius: '50%',
                center: ['40%', '50%'],
                label: {
                    formatter: '{b}\n{c}\n({d}%)',
                    edgeDistance: 10
                },
                data: data,
            }
        ]
    }

    return <ReactEcharts style={props.style} option={option}/>
}

export default PublisherPieChart
